export interface SalesDespatchItem {
  id: string;
  orderNo: string;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  shipperKey: string;
  shipperName: string;
  salesPack: number;
  proforma: string;
  proformaPaid: string;
  creditPassed: string;
  deliveryDate: Date;
  stockNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  notes: string;
  convertedQuantity: number;
  deliveryAddress: string;
  selected: boolean;
  shipper: string;
  sellingCompany: string;
  warehouse: string;
}
